import {
  Component,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  EventEmitter,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { TableCardColumnComponent } from '../table-card-column/table-card-column.component';

@Component({
  selector: 'ew-table-card-row',
  templateUrl: './table-card-row.component.html',
  styleUrls: ['./table-card-row.component.scss'],
})
export class TableCardRowComponent implements OnInit {
  @ViewChild(TemplateRef) content!: TemplateRef<any>;
  @ContentChildren(TableCardColumnComponent)
  columnsComponents!: QueryList<TableCardColumnComponent>;

  columns: Array<TableCardColumnComponent> = [];

  constructor() {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.columns = this.columnsComponents.toArray();
    }, 0);
  }
}
